import React from "react";
import { Box, SxProps, Theme } from "@mui/material";
import { StriimIconButton, StriimTypography } from "@striim/striim-ui";
import { aiButtonDisabledSxStyles, aiButtonSxStyles, StyledAiGradientIconButton } from "./ai-gradient-button.styles";
import styles from "../../striim-ai-sidebar.styles";

interface Props {
    icon: React.ReactNode;
    label?: React.ReactNode;
    onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    disabled?: boolean;
    size?: number;
    sx?: SxProps<Theme>;
    type?: "button" | "submit" | "reset";
}

const AiGradientButton: React.FC<Props> = ({ icon, label, onClick, disabled, size, sx, type = "button" }) => {
    if (label) {
        return (
            <StriimIconButton
                onClick={onClick}
                disabled={disabled}
                type={type}
                sx={[disabled ? aiButtonDisabledSxStyles : aiButtonSxStyles, sx]}
            >
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    {icon}
                    <StriimTypography variant="h3" color="greyscale.900" sx={styles.copilotHeaderTypography}>
                        {label}
                    </StriimTypography>
                </Box>
            </StriimIconButton>
        );
    }

    return (
        <StyledAiGradientIconButton
            // @ts-ignore
            buttonSize={size}
            onClick={onClick}
            disabled={disabled}
            sx={sx}
            type={type}
        >
            {icon}
        </StyledAiGradientIconButton>
    );
};

export default AiGradientButton;
